import "../App.css";
import logo from "../assets/logo.svg";
import martonszabolcs from "../assets/martonszabolcs.png";
import atrium1 from "../assets/photos/atrium1.png";
import atrium2 from "../assets/photos/atrium2.png";
import atrium3 from "../assets/photos/atrium3.png";
import fb from "../assets/icons/fb.png";
import insta from "../assets/icons/insta.png";
import yt from "../assets/icons/yt.png";
import spoti from "../assets/icons/spoti.png";
import event from "../assets/logos/event.png";
import patika from "../assets/logos/patika.png";
import szesz from "../assets/logos/szesz.png";
import torulaBlack from "../assets/logos/torulaBlack.png";
import kvarkMobile from "../assets/mobile_kvark.gif";

import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import GridLines from "react-gridlines";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import ModalImage from "react-modal-image";

const firebaseConfig = {
  apiKey: "AIzaSyCEB7TGU7Pds5L5ga3hDy7OrZl-KLARoSk",
  authDomain: "kvark-511ba.firebaseapp.com",
  projectId: "kvark-511ba",
  storageBucket: "kvark-511ba.appspot.com",
  messagingSenderId: "596623404975",
  appId: "1:596623404975:web:a8b7453c42536168d7095a",
  measurementId: "G-BSP8F9Q3H3",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

function App() {
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    var userLang = navigator.language || navigator.userLanguage;
    setLanguage(userLang.includes("hu") ? "hu" : userLang);
  }, []);

  const isHu = language === "hu";

  return (
    <div className="App font-spaceGrotesk overflow-x-hidden">
      <div id="fb-root"></div>
      <script
        async
        defer
        crossorigin="anonymous"
        src="https://connect.facebook.net/hu_HU/sdk.js#xfbml=1&version=v13.0&appId=778005422729456&autoLogAppEvents=1"
        nonce="ofWZBuYH"
      ></script>
      <div className="fixed bottom-0 z-20 pb-2 pt-2 w-full bg-black flex justify-center items-center">
        <img
          alt={"Gyori szesz"}
          src={szesz}
          onClick={() => openInNewTab("http://www.gyoriszesz.hu/hu")}
          className="w-8 h-8 cursor-pointer"
        />
        <img
          alt={"Torula"}
          src={torulaBlack}
          onClick={() => openInNewTab("https://www.torula.hu/")}
          className="w-10 h-10 mr-4 ml-4 cursor-pointer"
        />
        <img
          alt={"Event studio"}
          src={event}
          onClick={() => openInNewTab("https://www.eventstudio.hu/")}
          className="w-10 h-10 cursor-pointer"
        />
        <img
          alt={"Patika Berlin"}
          src={patika}
          onClick={() => openInNewTab("https://www.instagram.com/patika_berlin_presents/")}
          className="ml-4 w-10 h-10 cursor-pointer"
        />
       </div>
      <div
        className="p-3 md:p-4 z-30 fixed rounded-2xl right-4 bottom-16 md:right-16 flex items-center shadow-xl max-w-[calc(100vw-2rem)]"
        style={{ backgroundColor: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)' }}
      >
        <img
          src={logo}
          alt="MARTON"
          className="h-8 md:h-14 mr-3 md:mr-5"
          style={{ filter: 'brightness(1.1)' }}
        />
        <div className="h-8 md:h-10 w-px bg-white opacity-20 mr-3 md:mr-5"></div>
        <div className="flex items-center gap-2 md:gap-3">
          <div
            className="flex items-center px-3 py-2 md:px-4 md:py-3 rounded-xl cursor-pointer transition-opacity hover:opacity-90"
            style={{ backgroundColor: 'rgba(255,255,255,0.12)' }}
            onClick={() => openInNewTab("https://www.rokoko-park.de/")}
          >
            <div className="mr-2 md:mr-3">
              <p className="text-white font-bold text-xs md:text-base leading-tight">Rokoko-Park | Germany</p>
              <p className="text-white text-[10px] md:text-sm opacity-70">{isHu ? "2026. máj. 9." : "2026 May 9"}</p>
            </div>
            <p className="text-white font-bold text-xs md:text-base border-l border-white border-opacity-30 pl-2 md:pl-3">
              {isHu ? "Részletek" : "Details"}
            </p>
          </div>
          <div
            className="flex items-center px-4 py-2 md:px-5 md:py-3 rounded-xl cursor-pointer transition-opacity hover:opacity-90"
            style={{ backgroundColor: '#A5263B' }}
            onClick={() => openInNewTab("https://eventfrog.de/en/p/concerts/other-music-genres/marton-the-transient-symphony-die-transiente-symphonie-7428173065303893365.html")}
          >
            <p className="text-white font-bold text-xs md:text-base">
              {isHu ? "Jegyek" : "Tickets"}
            </p>
          </div>
        </div>
      </div>
      {/*  <div
        onClick={() =>
          openInNewTab(
            "https://eventfrog.de/en/p/concert/other-music-genres/the-symphony-of-transience-kvark-music-7249169156515290704.html"
          )
        }
        className="p-2 z-30  cursor-pointer fixed rounded-3xl right-5 bottom-16 md:right-20 bg-white flex items-center justify-center"
      >
        <div className="p-2">
          <h1 className="text-black font-bold text-xl">
            House of Music | Berlin
          </h1>
          <p className="text-black text-xl"> 2024. dec 7. 20:00</p>
        </div>
        <div className="font-bold mx-5 text-xl ">Info</div>
      </div> */}

      <Helmet>
        <title>MARTON — The Transient Symphony</title>
        <meta name="title" content="MARTON — The Transient Symphony" />
        <meta
          name="description"
          content="An audiovisual experiment by Marton Szabolcs. Twelve musicians, projection mapping, and a three-part journey through the meaning of transience."
        />
        <meta name="keywords" content="MARTON, Marton Szabolcs, The Transient Symphony, contemporary music, audiovisual, projection mapping, orchestra" />
        <meta name="author" content="Marton Szabolcs" />
        <meta name="robots" content="index, follow" />
        <meta name="theme-color" content="#000000" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:title" content="MARTON — The Transient Symphony" />
        <meta property="og:site_name" content="MARTON" />
        <meta
          property="og:description"
          content="An audiovisual experiment by Marton Szabolcs. Twelve musicians, projection mapping, and a three-part journey through the meaning of transience."
        />
        <meta property="og:image" content="https://www.martonsounds.com/og-image.png" />
        <meta property="og:image:secure_url" content="https://www.martonsounds.com/og-image.png" />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:locale:alternate" content="hu_HU" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="MARTON — The Transient Symphony" />
        <meta
          name="twitter:description"
          content="An audiovisual experiment by Marton Szabolcs. Twelve musicians, projection mapping, and a three-part journey through the meaning of transience."
        />
        <meta name="twitter:image" content="https://www.martonsounds.com/og-image.png" />

        <link rel="canonical" href="https://www.martonsounds.com" />
      </Helmet>

      <div className="bg-black text-left h-screen w-full md:bg-kvarkProd bg-no-repeat bg-cover bg-fixed relative overflow-hidden">
        {/* Mobile background */}
        <img
          alt={"marton"}
          src={kvarkMobile}
          className="absolute inset-0 w-full h-full md:hidden object-cover"
        />

        {/* Vignette overlay */}
        <div className="absolute inset-0 hero-vignette z-10"></div>

        {/* Bottom gradient */}
        <div className="absolute bottom-0 left-0 right-0 h-1/3 hero-gradient-bottom z-10"></div>



        {/* Scroll indicator */}
        <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2 z-10 hero-scroll">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="opacity-50">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
      </div>

      {/* Events Section */}
      <div className="w-full bg-black py-10 flex flex-col items-center">
        <div className="w-11/12 md:w-3/5 max-w-2xl">
          {/* Upcoming Events */}
          <h4 className="text-2xl font-bold mb-3 text-center tracking-widest uppercase" style={{ color: "#A5263B" }}>
            {isHu ? "KÖZELGŐ ESEMÉNYEK" : "UPCOMING EVENTS"}
          </h4>
          <div className="w-16 h-0.5 mx-auto mb-4" style={{ backgroundColor: "#A5263B" }}></div>
          <p className="text-base text-center text-white font-semibold mb-6">
            {isHu ? "2026. május 9. — Rokoko-Park | Németország" : "2026 May 9 — Rokoko-Park | Germany"}
          </p>

          <div className="w-full h-px bg-white opacity-20 mb-6"></div>

          {/* Past Events */}
          <p className="text-xs font-bold text-center tracking-[0.3em] uppercase text-white opacity-30 mb-6">
            {isHu ? "KORÁBBI ESEMÉNYEK" : "PAST EVENTS"}
          </p>

          <div className="flex flex-col md:flex-row md:justify-between gap-8">
            {/* 2024 */}
            <div className="flex-1">
              <div className="flex items-center mb-3">
                <div className="w-8 h-px mr-3" style={{ backgroundColor: '#A5263B' }}></div>
                <p className="text-sm font-bold tracking-widest" style={{ color: '#A5263B' }}>2024</p>
              </div>
              <div className="space-y-1.5 pl-11">
                <p className="text-xs text-white opacity-50">{isHu ? "Dec. 7. — House of Music | Berlin" : "Dec 7 — House of Music | Berlin"}</p>
                <p className="text-xs text-white opacity-50">{isHu ? "Júl. 7. — Zsolnay Fényfesztivál | Pécs" : "Jul 7 — Zsolnay Light Festival | Pécs"}</p>
                <p className="text-xs text-white opacity-50">{isHu ? "Jún. 8. — Art Piknik | Pannonhalma" : "Jun 8 — Art Piknik | Pannonhalma"}</p>
                <p className="text-xs text-white opacity-50">{isHu ? "Máj. 12. — Budapest 100 | Budapest" : "May 12 — Budapest 100 | Budapest"}</p>
                <p className="text-xs text-white opacity-50">{isHu ? "Máj. 9. — Ada Vilhan Opening | Budapest" : "May 9 — Ada Vilhan Opening | Budapest"}</p>
              </div>
            </div>

            {/* 2023 */}
            <div className="flex-1">
              <div className="flex items-center mb-3">
                <div className="w-8 h-px mr-3" style={{ backgroundColor: '#A5263B' }}></div>
                <p className="text-sm font-bold tracking-widest" style={{ color: '#A5263B' }}>2023</p>
              </div>
              <div className="space-y-1.5 pl-11">
                <p className="text-xs text-white opacity-50">{isHu ? "Okt. 8. — Torula | Győr" : "Oct 8 — Torula | Győr"}</p>
                <p className="text-xs text-white opacity-50">{isHu ? "Szept. 29. — Serum Light Festival | Somorja SK" : "Sep 29 — Serum Light Festival | Somorja SK"}</p>
                <p className="text-xs text-white opacity-50">{isHu ? "Jún. 17–18. — Veszprém-Balaton 2023 | Veszprém" : "Jun 17–18 — Veszprém-Balaton 2023 | Veszprém"}</p>
                <p className="text-xs text-white opacity-50">{isHu ? "Ápr. 20. — Budapesti Tavaszi Fesztivál | Kristály Színtér" : "Apr 20 — Budapest Spring Festival | Kristály Színtér"}</p>
              </div>
            </div>

            {/* 2022 */}
            <div className="flex-1">
              <div className="flex items-center mb-3">
                <div className="w-8 h-px mr-3" style={{ backgroundColor: '#A5263B' }}></div>
                <p className="text-sm font-bold tracking-widest" style={{ color: '#A5263B' }}>2022</p>
              </div>
              <div className="space-y-1.5 pl-11">
                <p className="text-xs text-white opacity-50">{isHu ? "Okt. — Átrium | Budapest" : "Oct — Átrium | Budapest"}</p>
                <p className="text-xs text-white opacity-50">{isHu ? "Máj. — Torula Művésztér | Győr" : "May — Torula ART | Győr"}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*   <div
        onClick={() => openInNewTab("https://tixa.hu/torula_gyarkoncert")}
        className="p-2 z-30  cursor-pointer fixed rounded-3xl right-5 bottom-10 md:right-20 bg-green flex items-center justify-center"
      >
        <div className="p-2">
          <h1 className="text-black font-bold text-xl">
            {isHu ? "MARTON Akusztik" : "MARTON Acoustic"}
          </h1>
          <p className="text-black text-left text-xl">
            {" "}
            {isHu ? "Torula | Győr" : "Torula | Győr"}
          </p>
        </div>
        <div className="font-bold mx-5 text-xl border-l pl-2 h-max ">
          {isHu ? "Jegyek" : "Tickets"}
        </div>
      </div> */}

      <GridLines
        className="text-left pt-24 pb-24 w-full bg-bgwhite flex flex-col items-center"
        cellWidth={125}
        strokeWidth={0.5}
        cellWidth2={125}
      >
        <div className="m-10 md:w-3/5 md:m-0 mt-0">
          <div class="aspect-w-16 mt-10 aspect-h-9 video rounded">
            <iframe
              title="MARTON European Cultural Capital 2023"
              src="https://www.youtube.com/embed/53tiW-32sW8"
              frameborder="5"
              className="rounded"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div className="text-xl mt-10 text-black">
            {isHu
              ? `Emberek vagyunk. Ennek a jelentése és jelentősége kultúránként,
            társadalmanként, egyénenként eltérő lehet. Mégis összeköt minket
            belső, legféltettebb énünk, elemi érzelmeink működési mechanizmusa
            és a közös félelmeink. A koncerten bemutatott egyedi audiovizuális
            installáció először látni engedi a saját lényünk mélyébe vezető
            útvesztő falait, hagy köztük eltévedni, és felteszi a kérdést:
            mekkora értéket ad nekünk a saját mulandóságunk? Erre próbál meg
            húsbavágó válaszokat adni a három részre tagolt zenei utazás – és
            egy élményt, ami által gazdagabbá válunk.`
              : "We’re human. The meaning and burden of this fact vary based on our individual cultural background, social status, our nature. Still, the innermost fragile pieces of our existence, the very working mechanisms of our feelings, and our shared elementary fears all tie us together. The unique audiovisual installation that’s made for the production at first sheds light on the walls of the maze that leads us to the deepest of ourselves, lets us wander and get lost in it while stating the question: how much worth does our transience hold? This music production aims to give meat-cuttingly raw answers to these questions in a three-part journey – and an experience that makes us more as a person. "}
          </div>
        </div>
      </GridLines>

      <div className="text-left pt-24 pb-24 w-full bg-black flex flex-col items-center">
        <div className="m-10 md:w-3/5 md:m-0 flex flex-col mt-0">
          <div className="flex justify-center items-center">
            <div className="flex mr-10 flex-col">
              <ModalImage
                small={atrium1}
                large={atrium1}
                alt="MARTON"
                className="rounded"
              />
              <div className="flex mt-2 ml-10 justify-center items-center">
                <ModalImage
                  small={atrium2}
                  large={atrium2}
                  alt="MARTON"
                  className="rounded"
                />
              </div>
            </div>
            <div className="h-full">
              <ModalImage
                small={atrium3}
                large={atrium3}
                alt="MARTON"
                className="rounded"
              />
            </div>
          </div>
          <h4 className=" text-3xl mt-10 mb-10 font-bold text-white">
            {isHu
              ? "AMIT MARTONRÓL TUDNI ÉRDEMES"
              : "WHAT'S THERE TO KNOW ABOUT MARTON? "}
          </h4>
          <div className="text-xl mt-10 lg:mt-0 text-white">
            {isHu
              ? `A MARTON zenekara 12 főből áll: vonósok, fúvósok, valamint zongora,
            dob és basszusgitár. A projekt egy egyedülálló művészeti és
            közösségi esemény. A három részre tagolt műsor alatt egy zenei
            kísérlet részesei lehetünk, aminek keretében garantáltan kilépünk a
            komfortzónánkból és együtt tapasztalhatunk valami egészen
            különleges, olykor már-már furcsán szürreális élményt.`
              : `The orchestra of MARTON consists of twelve musicians: strings, brass instruments, piano, drums, and a bass guitar. The project is an outstanding artistic and social event in which the audience participates in a musical experiment that's guaranteed to get one out of their comfort zone. The three-chaptered experience is special, collectively shared, and sometimes even a bit surreal, while every minute of it has its own individual kind of gravity.`}
          </div>
        </div>
      </div>

      <GridLines
        className="text-left pt-24 pb-24 w-full flex flex-col items-center"
        cellWidth={125}
        strokeWidth={0.5}
        cellWidth2={125}
      >
        <div className="m-10 md:w-3/5 md:m-0 mt-0">
          <div class="aspect-w-16 mt-10 aspect-h-9 video rounded">
            <iframe
              title="MARTON Interview"
              src="https://www.youtube.com/embed/o9iQsIwO1zo"
              frameborder="5"
              className="rounded"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div className="text-xl text-center italic mt-10 text-black">
            {isHu
              ? `“Pokolra tettem a lelkem, mikor a mulandóhoz úgy ragaszkodtam,
            mintha nem volna mulandó.”`
              : `“I condemned my soul to hell when I clung to the ephemeral as if it were not ephemeral.“`}
          </div>
          <div className="text-l text-right mt-2 text-black">
            {isHu
              ? "Szent Ágoston vallomásai"
              : "The Confessions of St. Augustine"}
          </div>

          <div className="text-xl mt-10 text-black">
            {isHu
              ? `Szokás mondani: az életben egy dolog állandó, az pedig a változás. A
            MARTON az emberi élet legelemibb részét mutatja be, a változás
            pillanatát. Azt a pillanatot, amiből naponta akár több ezer is
            megtörténik velünk, olykor szinte észrevétlenül. Tudjuk, hogy a
            létünk nem tarthat örökké. És mint mindennek, ami véges, tétje is
            van. A zenei kísérlet szakaszai (elidegenedés, utazás/flow és
            megérkezés) azonos alaptételen nyugszanak: tartanak valahonnan és
            valami felé, végesek, hiszen előre meghatározott keretek között
            működnek. Akárcsak az élet. Egyedül az alkotás az, amiben örökké
            élhetünk.`
              : `As the saying goes, the only thing that's static in life is change itself. MARTON magnifies the smallest particle of human existence: the moment of alteration.
              The moment, from which even thousands can happen to us every day, most of the time unnoticed. We know that our existence cannot last forever. And as everything that is finite, has a higher stake. The stages of the musical experiment (alienation, travel/flow, and arrival) are based on the same basic premise: they lead from somewhere towards something, they are finite, since they operate within a predetermined framework. Just like life. Creation is the only thing in which we can live forever.              
            `}
          </div>
          <div className="text-xl mt-10 text-black">
            {isHu
              ? `Látod, mekkora áldás, hogy halandók vagyunk?`
              : `Do you see what a blessing it is that we are mortal?`}
          </div>
        </div>
      </GridLines>
      <div className="text-left pt-24 pb-24 w-full bg-black flex flex-col items-center">
        <div className="px-6 md:px-10 md:w-3/5 md:mx-0 mt-0">
          <h4 className=" text-3xl  mb-12 font-bold text-green">
            {isHu ? "A STÁB" : "THE CREW"}
          </h4>
          <div className="lg:flex">
            <img
              src={martonszabolcs}
              alt="MartonSzabolcs"
              className="w-40 h-40 mr-5 rounded"
            />
            <div className="flex flex-col">
              <div className="text-xl mt-10 mb-5 lg:mt-0 text-white">
                <b>MARTON SZABOLCS</b>
              </div>
              <div className="text-xl mt-10 mb-4 lg:mt-0 text-white">
                {isHu
                  ? `Marton Szabolcs producer, zeneszerző. Az első debütálása
                dalszerzőként a ’Préda’ előadásához fűződik, amihez 2014-ben
                készített dalokat az Aurora Art felkérésére. Ugyanebben az évben
                indult az első saját zenekara is, a We are Infinite, amivel a
                budapesti Talentométer döntőjébe kerültek, illetve bejutottak a
                Hangfoglaló (akkori nevén Cseh Tamás) Program résztvevői közé
                is. 2016-ban ő szerezte a ’Vád’ című darab zenéjét, majd
                2017-ben elkészítette első saját nagylemezét, amit második
                zenekarával, a HÜGE-vel jegyez. Azóta elsődlegesen színházi- és
                filmzenék szerzőjeként van jelen a magyar zeneiparban. `
                  : `Marton Szabolcs, producer, and composer. His first debut, as a songwriter, was with the performance of 'Préda', for which he composed music in 2014 at the request of Aurora Art. In the same year, his first own band, “We are Infinite”, was launched, with which they reached the finals of the Talentometer in Budapest, and made it to the participants of the Hangfoglaló (then known as Tamás Cseh) Program. In 2016, he composed the music for the performance 'Vád', and in 2017 he produced his first LP, which he recorded with his second band, HÜGE. Since then, he has been primarily present in the Hungarian music industry as a composer of theater and film scores.`}
              </div>
              <div className="text-xl mt-10 lg:mt-0 text-white">
                {isHu
                  ? `Szabolcsot már egészen fiatal kamaszkora óta foglalkoztatta az a
                  kérdés, hogyan lehetne erős, jól érthető üzeneteket közvetíteni
                  pusztán instrumentális hangzással. Ez a gondolat végül 2021-re
                  érett benne konkrét zenei programmá, nekifogott a MARTON
                  megtervezésének és megvalósításának. A zeneszerzésen túl még
                  ugyanebben az évben a próbafolyamatok is elindultak, majd a
                  győri Torula Művésztér helyszínén otthonra is talált a kortárs
                  audiovizuális kísérletként körvonalazódó projekt.`
                  : `Since his early teens, Szabolcs has been concerned with the question of how to convey strong, easily understandable messages using only instrumental sounds. This idea finally matured into a concrete music program in 2021, and he started the planning and realization of MARTON. In addition to composing the music, the rehearsals also started in the same year, and the project, which was outlined as a contemporary audiovisual experiment, also found a home at the Torula Művésztér in Győr.`}
              </div>
            </div>
          </div>
        </div>
        <div className="px-6 md:px-10 flex flex-col md:flex-row md:justify-between md:w-3/5 sm:mt-10">
          <div className="flex flex-col mt-10">
            <div className="text-xl mt-10 mb-5 lg:mt-0 text-white">
              <b>TONKO BIANKA</b>
            </div>
            <div className="text-xl lg:mt-0 text-white">
              {isHu ? "Booking Manager (DE | EN | IT | HU)" : "Booking Manager (DE | EN | IT | HU)"}
            </div>
            <div className="text-lg underline lg:mt-0 text-white">
              bianka@martonsounds.com
            </div>
          </div>
          <div className="flex flex-col mt-10">
            <div className="text-xl mt-10 mb-5 lg:mt-0 text-white">
              <b>RÁKOSI TÍMEA</b>
            </div>
            <div className="text-xl lg:mt-0 text-white">
              {isHu ? "Booking Manager (HU)" : "Booking Manager (HU)"}
            </div>
            <div className="text-xl underline lg:mt-0 text-white">
              booking@kvarkmusic.com
            </div>
          </div>
        </div>
        <div className="px-6 md:px-10 flex flex-col md:flex-row md:justify-between md:w-3/5 sm:mt-10">
          <div className="flex flex-col mt-10">
            <div className="text-xl mt-10 mb-5 lg:mt-0 text-white">
              <b>KISS PATRIK</b>
            </div>
            <div className="text-xl lg:mt-0 text-white">Mapping</div>
          </div>
          <div className="flex flex-col mt-10">
            <div className="text-xl mt-10 mb-5 lg:mt-0 text-white">
              <b>KURUCZ ANDRÁS</b>
            </div>
            <div className="text-xl lg:mt-0 text-white">
              {isHu ? "Mapping rendezés" : "Mapping Director"}
            </div>
          </div>
        </div>
        <div className="px-6 md:px-10 flex flex-col md:flex-row md:justify-between md:w-3/5 sm:mt-10">
          <div className="flex flex-col mt-10">
            <div className="text-xl mt-10 mb-5 lg:mt-0 text-white">
              <b>MARTON ZSOLT</b>
            </div>
            <div className="text-xl lg:mt-0 text-white">Design</div>
          </div>
        </div>

        <div className="px-6 md:px-10 flex flex-col md:flex-row md:justify-between md:w-3/5 sm:mt-10">
          <div className="flex flex-col mt-10">
            <div className="text-xl mt-10 mb-5 lg:mt-0 text-white">
              <b>HAJMA PÉTER</b>
            </div>
            <div className="text-xl lg:mt-0 text-white">
              {isHu ? "Hangmérnök" : "Sound Engineer"}
            </div>
          </div>
          <div className="flex flex-col mt-10">
            <div className="text-xl mt-10 mb-5 lg:mt-0 text-white">
              <b>SIPOS BENCE</b>
            </div>
            <div className="text-xl lg:mt-0 text-white">
              {isHu ? "Hangmérnök" : "Sound Engineer"}
            </div>
          </div>
        </div>
      </div>
      <GridLines
        className="text-left pt-24 pb-24 w-full flex flex-col items-center"
        cellWidth={125}
        strokeWidth={0.5}
        cellWidth2={125}
      >
        <div className="m-10 md:w-3/5 md:m-0 mt-0">
          <div className="w-3/5 ">
            <h4 className=" text-2xl font-bold text-black">
              {isHu ? "Kapcsolat" : "Contact"}
            </h4>
            <div className="text-xl mt-10 text-black">
              hello@martonszabolcs.hu
              <br />
            </div>
            <div className="text-xl mt-2 text-black">
              booking@martonsounds.com
              <br />
            </div>
          </div>
          <div className="w-3/5 flex ">
            <img
              alt={"MARTON youtube"}
              onClick={() =>
                openInNewTab(
                  "https://www.youtube.com/channel/UCdFMZv6Wm47-QDMiyGbDF1w"
                )
              }
              src={yt}
              className="w-8 h-8 mr-4 mt-4 cursor-pointer"
            />
            <img
              alt={"MARTON spotify"}
              onClick={() =>
                openInNewTab(
                  "https://open.spotify.com/artist/3mfIMiojq40msnh10snKGP"
                )
              }
              src={spoti}
              className="w-8 h-8 mr-4 mt-4 cursor-pointer"
            />
            <img
              alt={"MARTON instagram"}
              onClick={() =>
                openInNewTab("https://www.instagram.com/martonszabolcs_/")
              }
              src={insta}
              className="w-8 h-8 mr-4 mt-4 cursor-pointer"
            />
            <img
              onClick={() =>
                openInNewTab("https://www.facebook.com/martonszabolcsmusic")
              }
              alt={"MARTON facebook"}
              src={fb}
              className="w-8 h-8 mr-4 mt-4 cursor-pointer"
            />
          </div>
          <div className="mt-24 text-xs text-black">
            {isHu
              ? "© Marton Szabolcs, 2026. Minden jog fenntartva."
              : "© Marton Szabolcs, 2026. All rights reserved."}
          </div>
        </div>
      </GridLines>
    </div>
  );
}

export default App;
